/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface ShopifyTagAccessorialRule
 */
export interface ShopifyTagAccessorialRule {
  /**
   *
   * @type {Array<string>}
   * @memberof ShopifyTagAccessorialRule
   */
  tags: Array<string>;
  /**
   *
   * @type {string}
   * @memberof ShopifyTagAccessorialRule
   */
  accessorial: string;
  /**
   *
   * @type {boolean}
   * @memberof ShopifyTagAccessorialRule
   */
  require: boolean;
}

/**
 * Check if a given object implements the ShopifyTagAccessorialRule interface.
 */
export function instanceOfShopifyTagAccessorialRule(
  value: object,
): value is ShopifyTagAccessorialRule {
  if (!("tags" in value) || value["tags"] === undefined) return false;
  if (!("accessorial" in value) || value["accessorial"] === undefined)
    return false;
  if (!("require" in value) || value["require"] === undefined) return false;
  return true;
}

export function ShopifyTagAccessorialRuleFromJSON(
  json: any,
): ShopifyTagAccessorialRule {
  return ShopifyTagAccessorialRuleFromJSONTyped(json, false);
}

export function ShopifyTagAccessorialRuleFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ShopifyTagAccessorialRule {
  if (json == null) {
    return json;
  }
  return {
    tags: json["tags"],
    accessorial: json["accessorial"],
    require: json["require"],
  };
}

export function ShopifyTagAccessorialRuleToJSON(
  json: any,
): ShopifyTagAccessorialRule {
  return ShopifyTagAccessorialRuleToJSONTyped(json, false);
}

export function ShopifyTagAccessorialRuleToJSONTyped(
  value?: ShopifyTagAccessorialRule | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    tags: value["tags"],
    accessorial: value["accessorial"],
    require: value["require"],
  };
}
